// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  BrandMemberRow,
  BrandPendingInviteRow,
} from "./types";


export default __t.row({
  get members() {
    return __t.array(BrandMemberRow);
  },
  get pendingInvites() {
    return __t.array(BrandPendingInviteRow).name("pending_invites");
  },
});
